import { Component } from '@angular/core';
import { AlertController,App} from 'ionic-angular';
import { StorageService } from '../../../providers/service/storageservice';
import { LoginPage } from '../../login/login/login';
import { AppState } from '../../../app/app.global';

import { HttpService } from '../../../providers/service/httpservice';
import { SAVE_UPDATE_PWD} from '../../../providers/config/serviceurl';
import { Utils} from '../../../providers/service/utils';
import { ToastAlert } from '../../../providers/util/toastalert';
@Component({
  selector: 'modify-pwd-page',
  templateUrl: 'modifypwd.html'
})
export class ModifyPasswordPage {
	user:any =null;
	oldPwd:string='';
	newPwd1:string='';
	newPwd2:string='';
	constructor (private alertCtrl: AlertController,public appCtrl: App,public global: AppState,
		private httpService:HttpService,public toastAlert: ToastAlert) {
		this.user = StorageService.getObj('currentUser');
	}

	ionViewWillEnter(){
		
	}	

	modifyPwd(){

		if(this.oldPwd == ""){
			let alert = this.alertCtrl.create({
				message: '请输入原密码',
				buttons: ['确定']
			});
			alert.present();
		}else if(this.newPwd1 == ""){
			let alert = this.alertCtrl.create({
				message: '请输入新密码',
				buttons: ['确定']
			});
			alert.present();
		}else if(this.newPwd2 == ""){
			let alert = this.alertCtrl.create({
				message: '请输入确认密码',
				buttons: ['确定']
			});
			alert.present();
		}else if(this.newPwd1!=this.newPwd2){
			let alert = this.alertCtrl.create({
				message: '两次输入的的新密码不一致',
				buttons: ['确定']
			});
			alert.present();
		}else {
			const accountpwdstrength = Utils.checkPassword(this.newPwd1);
			if(accountpwdstrength == "0"){
				let alert = this.alertCtrl.create({
					message: '输入密码过于简单，请重新输入',
					buttons: ['确定']
				});
				alert.present();
			}else{
				let params = {"username":this.user.username,"oldPwd":this.oldPwd,"newPwd":this.newPwd1,"confirmPwd":this.newPwd2,'pwdStrength':accountpwdstrength};
			 	this.httpService.post2(SAVE_UPDATE_PWD,params).then(anyObj =>this.handleModifyPwd(anyObj));
			}
		}
	}
	handleModifyPwd(obj:any){
		if(obj){
			if( obj.status=='success'){
				let alert = this.alertCtrl.create({
				message: '密码修改成功,请重新登录',
				buttons: [
				 {
					 text:'确定',
					 handler:() =>{
					 	StorageService.remove('currentUser');
						this.appCtrl.getRootNav().push(LoginPage);
					 }
				  }
				 ]
			  	});
				alert.present();
			}else{
				this.toastAlert.alertMsg(obj.message, 'middle', 1000);
			}
		}
		
	}

	
}



// WEBPACK FOOTER //
// ./src/pages/about/password/modifypwd.ts